/** ****************************************************************************
 * The DevLoggingUtility file is for controlling console.logs that are useful
 * to the developers, by offering global toggle (const boolean in this file)
 * but also a parameter that can override the global setting.
 *
 * The constant boolean "ARE_GLOBAL_LOGS_ENABLED" can be set to turn on/off all
 * console.logs meant for the developers at once.
 *
 * The function writeDevLog has parameter individualLogEnabled that will
 * override the global boolean.
 *
 * This allows for ALL logs, NO logs, or a fine-grained mixture of logs, while
 * preserving useful console logs in the code.
 *
 * @file   Developer Logging Utility
 * @author Paul J Stales
 * @since  2.0.0
 **************************************************************************** */

/** Global constant for all console.log meant for developers */
const ARE_GLOBAL_LOGS_ENABLED: boolean = true

/** These are in-house uses that currently have logs enabled */
const INTERNAL_PARTNER_IDS = [
  'TESTS',
  'VALIDATIONS',
  'PI0PJSRULZ',
  '1PJSisGR8-stv3-4t0m-n1cK-iFr4m3f0r3ver'
]

const PARTNER_IDS_WITH_LOGS_ENABLED: string[] = [
  ...INTERNAL_PARTNER_IDS,
  'fb1182a4-d8b2-481b-ab56-8768f482ac22'
]

/**
 * Function writeDevLog determines if an individual developer log should be shown.
 *
 * At runtime, the dev logs will use the current PartnerID.
 * Developer logs will be shown if the PartnerID is one of the partners
 * with logs enabled for them - these are set above.
 *
 * Developer logs should be shown if
 * 1 the partner has logs enabled and this individual log is enabled (overriding global)
 * 2 the partner has logs enabled and logs are enabled globally
 * @param log
 * @param partnerId
 * @param individualLogEnabled
 */
export function _devLog(
  log: string | any,
  partnerId?: string,
  individualLogEnabled?: boolean
): void {
  //console.log('What is the partnerId on devlog? ' + partnerId)

  // only show logs to partners who need logs
  if (
    partnerId !== undefined &&
    partnerId !== null &&
    PARTNER_IDS_WITH_LOGS_ENABLED.includes(partnerId)
  ) {
    // only show logs that are active, either globally or individually
    // where individually ranks above global
    // note that individual being undefined is indifferent, but false is disabled
    if (individualLogEnabled === true || ARE_GLOBAL_LOGS_ENABLED) {
      console.log(log)
    }
  }
}
